export const buildOrderDetails = (cart, packings) => {
  const details = []

  cart.forEach(item => {
    details.push({
      merchandise_id: item.merchandiseId,
      price_type_id: item.priceTypeId,
      size: item.size,
      packing_id: item.packingId,
      price: item.price,
      qty: item.qty,
      amount: item.amount,
    })
  })

  if (packings.length > 0) {
    packings.forEach(item => {
      details.push({
        merchandise_id: item.merchandiseId,
        price_type_id: item.priceTypeId,
        size: item.size,
        packing_id: item.packingId,
        price: item.price,
        qty: item.qty,
        amount: item.amount,
      })
    })
  }

  return details
}
